import { render, staticRenderFns } from "./DetalleSale.vue?vue&type=template&id=f6846908&scoped=true"
import script from "./DetalleSale.vue?vue&type=script&lang=js"
export * from "./DetalleSale.vue?vue&type=script&lang=js"
import style0 from "./DetalleSale.vue?vue&type=style&index=0&id=f6846908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6846908",
  null
  
)

export default component.exports